import {Component} from '@angular/core';

@Component({
  selector: 'app-ts-v2-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
})
export class V2FaqSectionComponent {
  faqs = Array.from({length: 10}, (_, i) => ({
    questionKey: `talentSearchV2.faq.q${i + 1}`,
    answerKey: `talentSearchV2.faq.a${i + 1}`,
    isOpen: false,
  }));
}
